import { isNone } from '@ember/utils';
import { computed } from '@ember/object';
export default function notNone(key) {
  return computed(key, function () {
    return !isNone(this.get(key));
  });
}